import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { Modal, Nav } from 'react-bootstrap'

import Search from 'pages/parts/Search'
import Pagination from 'pages/parts/Pagination'

import { PGET, PUT } from 'helpers/api'
import { checkRole, findFromArrayById, formatMoney, regexPhoneNumber } from 'helpers/helpers'
import { Link } from "react-router-dom"

function Index() {
	const URL = "/services/web/api/users-pageList"
	const { t } = useTranslation()

	const currencies = [{ "id": 1, "name": "So`m" }, { "id": 2, "name": "USD" }]

	const settings = useSelector(state => state.settings)

	const canCreate = checkRole('MAIN_USERS_ADD')
	const canUpdate = checkRole('MAIN_USERS_EDIT')

	const [pageCount, setPageCount] = useState(0)
	const [data, setData] = useState([])
	const [activeTab, setActiveTab] = useState('active')
	const [confirmTarget, setConfirmTarget] = useState(null)

	async function getData(tab = activeTab) {
		const response = await PGET(URL, { active: tab === 'active' }, { loader: true })
		if (response) {
			setPageCount(Math.ceil(response.headers['x-total-count'] / settings.size))
			setData(response.data)
		}
	}

	async function paginate(data) {
		const response = await PGET(URL, { page: data.selected, size: settings.size, active: activeTab === 'active' })
		setData(response.data);
	}

	async function search(data, searchValue) {
		setData(data);
		if (searchValue.length > 0) {
			setPageCount(0)
		}
	}

	async function setActive(id, nextActive) {
		const response = await PUT(`/services/web/api/users-activate/${id}?active=${nextActive}`, {}, { loader: true })
		if (response) {
			setConfirmTarget(null)
			getData()
		}
	}

	function switchTab(key) {
		if (key === activeTab) return
		setActiveTab(key)
		getData(key)
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between mb-2">
				<h4 className="vertical-center">
					{t('MY_USERS')}
				</h4>
				{(canCreate && activeTab === 'active') &&
					<div className="d-flex">
						<Link className="btn-rounded btn btn-primary" to={`/workers/create`}>
							<i className="uil uil-plus me-2"></i>
							{t('CREATE')}
						</Link>
					</div>
				}
			</div>

			<div className="card">
				<div className="card-body">
					<Nav className="mb-3" variant="tabs" activeKey={activeTab} onSelect={(key) => switchTab(key)}>
						<Nav.Item>
							<Nav.Link as="button" type="button" eventKey="active">{t('ACTIVE')}</Nav.Link>
						</Nav.Item>
						<Nav.Item>
							<Nav.Link as="button" type="button" eventKey="inactive">{t('INACTIVE')}</Nav.Link>
						</Nav.Item>
					</Nav>

					<div className="d-flex mb-3">
						<div className="me-2">
							<Search url={URL} search={search} getData={getData}></Search>
						</div>
					</div>
					<div className="table-responsive">
						<table className="table table-striped mb-0">
							<thead>
								<tr>
									<th>{t('FIO')}</th>
									<th>{t('LOGIN')}</th>
									<th>{t('PHONE')}</th>
									<th>{t('POSES')}</th>
									<th className="text-end">{t('ROLE')}</th>
									<th className="text-end">{t('CURRENCY')}</th>
									<th className="text-end">{t('SALARY')}</th>
									<th className="text-center">{t('ACTION')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.map((item, index) => (
									<tr key={index}>
										<td>{index + 1}. {item.firstName} {item.lastName}</td>
										<td>{item.userLogin}</td>
										<td>{regexPhoneNumber(item.phone)}</td>
										<td>{item.posNames || '-'}</td>
										<td className="text-end">{item.roleName ?? '-'}</td>
										<td className="text-end">{findFromArrayById(currencies, item.salaryCurrencyId)}</td>
										<td className="text-end">{formatMoney(item.salaryAmout)}</td>
										<td className="d-flex justify-content-center">
											{(canUpdate && activeTab === 'active') &&
												<Link className="table-action-button table-action-primary-button me-2" to={`/workers/update/${item.id}`}>
													<i className="uil-edit-alt"></i>
												</Link>
											}
											{canUpdate &&
												<button type="button"
													className={`table-action-button ${activeTab === 'active' ? 'table-action-danger-button' : 'table-action-success-button'}`}
													onClick={() => setConfirmTarget({
														id: item.id,
														name: `${item.firstName} ${item.lastName || ''}`.trim(),
														nextActive: activeTab !== 'active'
													})}>
													<i className={activeTab === 'active' ? 'uil-ban' : 'uil-check-circle'}></i>
												</button>
											}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					<Pagination pageCount={pageCount} paginate={paginate}></Pagination>
				</div>
			</div>

			<Modal show={!!confirmTarget} animation={false} centered backdrop="static" onHide={() => setConfirmTarget(null)}>
				<Modal.Header closeButton>
					<Modal.Title>{confirmTarget?.nextActive ? t('ACTIVATE') : t('DEACTIVATE')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{confirmTarget?.nextActive
						? t('CONFIRM_ACTIVATE_USER', { name: confirmTarget?.name })
						: t('CONFIRM_DEACTIVATE_USER', { name: confirmTarget?.name })
					}
				</Modal.Body>
				<Modal.Footer>
					<button type="button" className="btn btn-outline-warning" onClick={() => setConfirmTarget(null)}>{t('CANCEL')}</button>
					<button type="button"
						className={`btn ${confirmTarget?.nextActive ? 'btn-success' : 'btn-danger'}`}
						onClick={() => setActive(confirmTarget.id, confirmTarget.nextActive)}>
						{confirmTarget?.nextActive ? t('ACTIVATE') : t('DEACTIVATE')}
					</button>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default Index
